"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var DefaultBodyStyles_1 = __importDefault(require("./DefaultBodyStyles"));
var DefaultRecommended_1 = __importDefault(require("./DefaultRecommended"));
var DefaultTrending_1 = __importDefault(require("./DefaultTrending"));
function DefaultSuggestions(_a) {
    var handleDefaultSuggestionClicked = _a.handleDefaultSuggestionClicked, _b = _a.inModal, inModal = _b === void 0 ? false : _b;
    return (react_1.default.createElement("div", { className: "flex h-auto flex-col gap-24", "data-qa": "Default Search Suggestions" },
        react_1.default.createElement(DefaultBodyStyles_1.default, { inModal: inModal, handleDefaultSuggestionClicked: handleDefaultSuggestionClicked }),
        react_1.default.createElement(DefaultRecommended_1.default, { handleDefaultSuggestionClicked: handleDefaultSuggestionClicked }),
        react_1.default.createElement(DefaultTrending_1.default, { handleDefaultSuggestionClicked: handleDefaultSuggestionClicked })));
}
exports.default = DefaultSuggestions;
//# sourceMappingURL=DefaultSuggestions.js.map